import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import {TABLE_TYPE} from '../../Config/appConfig';

interface BatchInputCodeTableViewHeaderProps {
    tableType: string
}

class BatchInputCodeTableViewHeader extends React.Component <BatchInputCodeTableViewHeaderProps, {}> {
    public getHeaderTitle() {
        let colTitle1 = '';
        let colTitle2 = '';
        switch (this.props.tableType) {
            case TABLE_TYPE.INSURANCE:
                colTitle1 = 'Insurance Company Code';
                colTitle2 = 'Insurance Company';
                break;
            case TABLE_TYPE.ACTION:
                colTitle1 = 'Action code';
                colTitle2 = 'Action';
                break;
            default: break;
        }
        return {colTitle1, colTitle2}
    }

    public render() {
        const titles = this.getHeaderTitle();
        return (
            <div className="cmTableViewHeader">
                <Grid className="cmTableViewHeaderCol" item xs={3}>
                    <div className="cmTableViewHeaderContainer batchInputCodeTableViewHeaderContainer">
                        <div className="cmTableViewHeaderTitle batchInputCodeTableViewHeaderTitleLeft">{titles.colTitle1}</div>
                    </div>
                </Grid>
                <Grid className="cmTableViewHeaderCol" item xs={9}>
                    <div className="cmTableViewHeaderContainer">
                        <div className="cmTableViewHeaderTitle">{titles.colTitle2}</div>
                    </div>
                </Grid>
            </div>
        );
    }

}

export default BatchInputCodeTableViewHeader;


// WEBPACK FOOTER //
// ./src/Components/Batch/BatchInputCodeTableViewHeader.tsx